import APIKit from "../Allapis/Apikit/apikit";

export const uploadImageServer = async (file) => {
  const res = await APIKit.post(`/users/uploadImage`, file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};
